import styled, { css } from 'styled-components';

export const StyledCoverTile = styled.button<{
  $image?: string;
  $height: number;
  $dragging?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ $height }) => $height}px;
  padding: ${({ theme }) => theme.spacing.m}px;
  text-align: center;
  border: 1px dashed ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.borderRadius.m}px;
  background-color: ${({ theme }) => theme.colors.backgroundTertiary};
  background-image: ${({ $image }) => ($image ? `url(${$image})` : 'none')};
  background-size: cover;
  background-position: center;
  color: ${({ theme }) => theme.colors.textMuted};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  ${({ $dragging, theme }) =>
    $dragging &&
    css`
      border-color: ${theme.colors.primary};
      background-color: ${theme.colors.surfaceHover};
      /* The lit fill needs the brighter step to stay readable. */
      color: ${theme.colors.textSecondary};
    `}
`;
